module.exports = __webpack_public_path__ + "img/kolaydernek-gorseli-700x450.62973831.png";